import React, { useState, useEffect } from "react";
import { Modal, Form, Row, div, Button, Image, Col } from "react-bootstrap";
import InputBox from "../../common/InputBox";
import MultiSearchSelect from "../../common/multiSelect";
import xclose from "../../../assets/icons/x-close.svg";
import { addDiscount, getSalesUser } from "../../../services/discount-services";
import { getMasterData } from "../../../services/enquiryMaster-service";
import SearchSelect from "../../common/SearchSelect";
import MySwal from "sweetalert2";
import Alert from "../../common/Alert";
import Loader from "../../../assets/loader.gif";
import { deleteFile, downloadFile, getFileNames, getPresignedUrl, uploadFileToS3 } from "../../../services/timeline-service";
import DragDropRender from "../../common/DrapDropRender";
import axios from "axios";

const DiscountAdd = (props) => {

  const [formValues, setFormValues] = useState(props.rowdata ?
    {
      ...props.rowdata,
      field_16: props.rowdata.field_16 * 100,
      // field_19: props.rowdata.field_19 * 100,
      // field_27: props.rowdata.field_27 * 100
    } : {
      ID: "",
      Created: new Date().toISOString().split('T')[0],
      Title: "",
      field_5: "",
      field_6: "",
      Enquirytype: "",
      DealerSalesManager: "",
      Sales_x0020_ManagerId: "",
      field_12: "",
      field_13: "",
      field_14: "",
      field_15: [],
      field_17: "",
      field_16: "",
      field_18: "",
      // field_19: "",
      // field_34: "",
      // field_27: "",
      field_22: "",
      // field_21: "",
      field_23: "",
      field_24: [],
      field_28: new Date().toISOString().split('T')[0],
      field_29: new Date().toISOString().split('T')[0],
      field_30: "No",
      LDperweek: "",
      MaxLD: "",
      field_35: "",
      field_31: "",
      Approvalstatus: "Pending\n",
      Advance: "Not applicable",
      Creditperiod: "<= 30 days",
      ApproverComments: "",
      LastPendingWith: "",
      FinalApproverEmail: "",
      Insurance: "No"
    });
  const [errors, setErrors] = useState({});
  const [mandatoryFields, setMandatoryFields] = useState([]);
  const [masterData, setMasterData] = useState([]);
  const [salesuser, setSalesuser] = useState([])
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [obj, setObj] = useState([]);
  const [error, setError] = useState({});
  const [fileNames, setFileNames] = useState([]);
  

  const insuranceOptions = [
    { props: { value: 'Yes', children: 'Yes' } },
    { props: { value: 'No', children: 'No' } }
  ]

  const getDropDownOptions = (title) => {
    return masterData.filter((Type) => Type.title === title).flatMap((Type) => Type.value.split(','))
      .map((value) => (
        <option key={value} value={value}>
          {value}
        </option>
      ));
  };

  const pgOption = []
  masterData.filter((Type) => Type.title === "PG").flatMap((Type) => Type.value.split(',')).map((value) => {
    pgOption.push(value)
    return (
      <option key={value} value={value}>
        {value}
      </option>
    )
  });

  const CompetitorOption = []
  masterData.filter((Type) => Type.title === "Competitor").flatMap((Type) => Type.value.split(',')).map((value) => {
    CompetitorOption.push(value)
    return (
      <option key={value} value={value}>
        {value}
      </option>
    )
  });

  const dropdownOpen = salesuser.map((item) => (
    <option key={item.field_1} value={item.SalespersonId}>
      {item.field_1}
    </option>
  ));


  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getSalesUser();
      setSalesuser(result.data.map((item) => ({ field_1: item.field_1, SalespersonId: item.SalespersonId })));

      const values = await getMasterData();
      setMasterData(values.data.map((item) => ({ title: item.Title, value: item.Value })));
    }
    catch (exception) {
      console.log("exception", exception);
    }
    setLoading(false);
  };

  const extractData = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (data.results && Array.isArray(data.results)) return data.results;
    if (typeof data === 'string') return [data];
    return [data];
  };

  useEffect(() => {
    if (props.enquiryData && props.show) {
      setFormValues(prev => ({
        ...prev,
        Title: props.enquiryData.Title || "",
        field_5: props.EnquiryID || "",
        field_6: props.enquiryData.AccountName || "",
        Enquirytype: props.enquiryData.EnquiryType || "",
        DealerSalesManager: JSON.parse(sessionStorage.getItem('UserData'))?.UserData?.field_2 || "",
        field_12: props.enquiryData.SSGTerritory || "",
        field_13: JSON.parse(sessionStorage.getItem('UserData'))?.UserData?.Title || "",
        field_14: props.enquiryData.DeliveryLocation || "",
        field_15: extractData(props.enquiryData.PG),
        field_24: extractData(props.enquiryData.Competitor),
        Approvalstatus: "Pending\n",
        Sales_x0020_ManagerId: props.enquiryData.AssignedtoId || ""
      }));
    }

    fetchData()
  }, [props.enquiryData, props.show]);

  let maxFileSize = 52428800;

  let acceptedExtensions = {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-excel": [".xls"]
  };

  const commonFileUploadProps = {
    maxSize: maxFileSize,
    acceptedExtensions: acceptedExtensions,
    maxFiles: 5,
    isMultiple: true,
    maxTotalSize: 52428800
  };

  const commonProps = {
    setObj: setObj,
    setError: setError,
    error: error,
    mandatoryFields: mandatoryFields,
    setMandatoryFields: setMandatoryFields
  };

  async function getFilename(discountId) {
      console.log('discountId ', discountId);
  
      try {
        let filenames = await getFileNames(Number(discountId),'discount');
        console.log('filename filename', filenames);
  
        setFileNames(filenames);
      } catch (error) {
        console.log('error', error);
      }
    }

  useEffect(() => {
    const bom = parseFloat(formValues.field_17);
    const discount = parseFloat(formValues.field_16);
    if (!isNaN(bom) && !isNaN(discount)) {
      const calculated = (bom * (1 - discount / 100)).toFixed(2);
      setFormValues(prev => ({ ...prev, field_18: calculated }));
    } else {
      setFormValues(prev => ({ ...prev, field_18: "" }));
    }
  }, [formValues.field_17, formValues.field_16]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

   const handleChangeStatus = (files, fieldName) => {
      setLoading(true);
      const existingFiles = file[fieldName] || [];
      const existingFileNames = obj[fieldName] || [];
  
      const newFiles = Array.from(files).slice(0, 5 - existingFiles.length);
  
      // Check total size limit
      const existingSize = existingFiles.reduce((sum, f) => sum + (f.size || 0), 0);
      const newSize = newFiles.reduce((sum, f) => sum + f.size, 0);
      const totalSize = existingSize + newSize;
  
      if (totalSize > commonFileUploadProps.maxTotalSize) {
        const errMsg = `Total file size cannot exceed ${(commonFileUploadProps.maxTotalSize / 1048576).toFixed(0)}MB. Current: ${(totalSize / 1048576).toFixed(2)}MB`;
        Alert('error', errMsg);
        setLoading(false);
        return;
      }
  
      const newFileNames = newFiles.map(f => f.name);
  
      setFile((prev) => ({
        ...prev,
        [fieldName]: [...existingFiles, ...newFiles]
      }));
      setObj((prevState) => ({
        ...prevState,
        [fieldName]: [...existingFileNames, ...newFileNames],
      }));
      setLoading(false);
    };
  
     const handleDeleteDocument = (index, fieldName) => {
    setFile((prev) => {
      const updatedFiles = [...(prev[fieldName] || [])];
      updatedFiles.splice(index, 1);
      return {
        ...prev,
        [fieldName]: updatedFiles
      };
    });
    setObj((prev) => {
      const updatedNames = [...(prev[fieldName] || [])];
      updatedNames.splice(index, 1);
      return {
        ...prev,
        [fieldName]: updatedNames
      };
    });
  };

    const handleUploadedFileDownload = (fileName) => {
    const fileIndex = obj.AddDiscountDocument?.indexOf(fileName);
    if (fileIndex !== -1 && file.AddDiscountDocument?.[fileIndex]) {
      const fileObj = file.AddDiscountDocument[fileIndex];
      const url = URL.createObjectURL(fileObj);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileObj.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

    const handleFileDownload = async (filename) => {
      try {
        setLoading(true);
        const response = await downloadFile(props.rowdata?.ID, filename,'discount');
  
        if (response.data && response.data.downloadUrl) {
          const fileResponse = await axios.get(response.data.downloadUrl, { responseType: 'blob' });
          const url = window.URL.createObjectURL(fileResponse.data);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
  
          await handleFileDelete(response.data.fileKey);
        }
  
      } catch (error) {
        console.error('Error downloading file:', error);
        Alert('error', 'Failed to download file');
      } finally {
        setLoading(false);
      }
    };

     const handleFileDelete = async (fileKey) => {
      console.log("file key",fileKey)
        try {
          setLoading(true);
          await deleteFile(fileKey,'discount');
          console.log('File deleted successfully');
          await getFilename(props.rowdata.ID);
        } catch (error) {
          console.log('Failed to delete file');
        } finally {
          setLoading(false);
        }
      };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // Upload files to S3 using presigned URLs
            const uploadedFileKeys = [];
            if (file.AddDiscountDocument && file.AddDiscountDocument.length > 0) {
              for (const f of file.AddDiscountDocument) {
                try {
                  const presignedResponse = await getPresignedUrl(f.name, f.size, formValues.field_5,'Discount');
                  console.log("presignedresponse",presignedResponse.data)
                  const presignedData = JSON.parse(presignedResponse.data);
                  await uploadFileToS3(presignedData.uploadUrl, f);
                  console.log("uploaded to s3",presignedData.uploadUrl);
                  uploadedFileKeys.push(presignedData.Key);
                } catch (uploadError) {
                  console.error('File upload error:', uploadError);
                  Alert('error', `Failed to upload file: ${f.name}`);
                  setLoading(false);
                  return;
                }
              }
            }
            
      let datasave = await addDiscount({ ...formValues, fileKeys: uploadedFileKeys.length > 0 ? JSON.stringify(uploadedFileKeys) : null });
      const Id = datasave.data?.ID || datasave.ID || 'Unknown';
      Alert("success", `${Id} Discount Sanction is created`);
      props.onHide();
      props.hideForm(false);
      setLoading(false);

    } catch (error) {
      setLoading(false);
      Alert("error", error.data.message);
    }
  };

  const resetForm = () => {
    setFormValues((prev) => ({
      ...prev,
      ID: "",
      Created: new Date().toISOString().split('T')[0],
      //Title: "",
      //field_5: "",
      //field_6: "",
      Enquirytype: props.enquiryData.EnquiryType || "",
      //DealerSalesManager: "",
      //Sales_x0020_Manager: "",
      //field_12: "",
      //field_13: "",
      field_14: props.enquiryData.DeliveryLocation || "",
      field_15: extractData(props.enquiryData.PG),
      field_17: "",
      field_16: "",
      field_18: "",
      // field_19: "",
      // field_34: "",
      // field_27: "",
      field_22: "",
      // field_21: "",
      field_23: "",
      field_24: extractData(props.enquiryData.Competitor),
      field_28: new Date().toISOString().split('T')[0],
      field_29: new Date().toISOString().split('T')[0],
      field_30: "No",
      LDperweek: "",
      MaxLD: "",
      field_35: "",
      field_31: "",
      Approvalstatus: "Pending\n",
      Advance: "Not applicable",
      Creditperiod: "<= 30 days",
      ApproverComments: "",
      //LastPendingWith: "",
      FinalApproverEmail: "",
      Insurance: "No",
      Sales_x0020_ManagerId: props.enquiryData.AssignedtoId || ""
    }));
    setErrors({});
    setMandatoryFields([]);
    setFile([]);
    setObj([]);
  };

  const handleClose = () => {
    resetForm();
    props.onHide();
  };

  const isFormValid = () => {
    const requiredFields = [
      'Created', 'Title', 'field_5', 'field_6', 'Enquirytype', 'Sales_x0020_ManagerId',
      'DealerSalesManager', 'field_12', 'field_13', 'field_14',
      'field_15', 'field_17', 'field_16', 'field_18',
      // , 'field_19', 'field_27', 'field_34',
      'field_22', 'field_28', 'field_29', 'field_30', 'Approvalstatus',
      'Advance', 'Creditperiod', 'Insurance'
    ];

    const hasErrors = Object.values(errors).some(error => error !== "");

    const allFieldsFilled = requiredFields.every(field => {
      const value = formValues[field];
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value && value.toString().trim() !== '';
    });

    return allFieldsFilled && !hasErrors;
  };

   useEffect(() => {
    console.log("props.rowdata?.ID:: ", props.rowdata?.ID)
    if (props.rowdata?.ID && props.action === "View") {
      getFilename(props.rowdata.ID);
    }
  }, [props.rowdata?.ID, props.action]);

  return (
    <>
      {loading && (<div className="loader-box"> <img src={Loader} alt="Loading" className="newloader"></img> </div>)}

      <Modal show={props.show} size="xl" backdrop="static" className="ProjectModal">
        <Modal.Header>
          <Modal.Title>{props.action === "View" ? "View Discount Sanction" : "Add Discount Sanction"}</Modal.Title>
          <Image src={xclose} onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className="mandatory-note">* Mandatory fields</div>
          <Form onSubmit={handleSubmit}>
            <div className="scrollForm">
              <div className="form-right-adjust">

                <Row className="modal-row add-edit-form">
                  {/* <InputBox
                type="text"
                name="ID" set
                value={formValues.ID}
                label="Discount ID*"
                fieldName="ID"
                onChange={handleInputChange}
                required
                mandatoryFields={mandatoryFields}
                setMandatoryFields={setMandatoryFields}
                setError={setErrors}
                error={errors.ID}
                isAlphanumericWithSpecialChars
                readOnly
                maxLength={50}
              /> */}
                  <InputBox
                    type="date"
                    name="Created"
                    value={formValues.Created?.split("T")[0]}
                    label="Created Date*"
                    fieldName="Created Date"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.Created}
                    readOnly
                  />

                  <InputBox
                    type="text"
                    name="Title"
                    value={formValues.Title}
                    label="Quote Name*"
                    fieldName="Quote Name"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.Title}
                    // readOnly
                    maxLength={100}
                  />

                  <InputBox
                    type="text"
                    name="field_5"
                    value={formValues.field_5}
                    label="Enquiry No.*"
                    fieldName="Enquiry No"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_5}
                    // hint="Auto-populated from enquiry"
                    readOnly
                  />
                </Row>

                <Row className="modal-row add-edit-form">

                  <InputBox
                    type="text"
                    name="field_6"
                    value={formValues.field_6}
                    label="Account Name*"
                    fieldName="Account Name"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_6}
                    // hint="Auto-populated from enquiry"
                    readOnly
                  />
                  <InputBox
                    type="text"
                    name="DealerSalesManager"
                    value={formValues.DealerSalesManager}
                    label="Dealer Sales Person*"
                    fieldName="Dealer Sales Person"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.DealerSalesManager}
                    readOnly
                    hint="Based on login"
                  />

                  <SearchSelect
                    name="Enquirytype"
                    value={formValues.Enquirytype}
                    option={getDropDownOptions("Enquiry type")}
                    label="Enquiry Type*"
                    id="Enquirytype"
                    fieldName="Enquiry Type"
                    onChange={handleInputChange}
                    placeholder="Select Enquiry Type"
                    setError={setErrors}
                    error={errors.Enquirytype}
                    required
                    readOnly={props.action == 'View' && true}
                  />
                </Row>

                <Row className="modal-row add-edit-form">
                  <SearchSelect
                    name="Sales_x0020_ManagerId"
                    value={formValues.Sales_x0020_ManagerId}
                    option={dropdownOpen}
                    label="Sales Manager*"
                    id="Sales_x0020_Manager"
                    fieldName="Sales Manager"
                    onChange={handleInputChange}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    placeholder="Select Sales Manager"
                    setError={setErrors}
                    error={errors.Sales_x0020_ManagerId}
                    required
                    disabled={props.action != 'View' && true}
                    readOnly={props.action == 'View' && true}
                  />

                  <SearchSelect
                    name="field_12"
                    value={formValues.field_12}
                    option={getDropDownOptions("Sales Branch List")}
                    label="Branch*"
                    id="field_12"
                    fieldName="Branch"
                    onChange={handleInputChange}
                    placeholder="Select Branch"
                    setError={setErrors}
                    error={errors.field_12}
                    required
                    readOnly
                  />

                  <InputBox
                    type="text"
                    name="field_13"
                    value={formValues.field_13}
                    label="Dealer Name*"
                    fieldName="Dealer Name"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_13}
                    readOnly
                    // hint="Auto-populated based on login"
                  />
                </Row>

                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="text"
                    name="field_14"
                    value={formValues.field_14}
                    label="Delivery Location*"
                    fieldName="Delivery Location"
                    onChange={handleInputChange}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_14}
                    readOnly={props.action == 'View' && true}
                    // hint="Auto-populated from enquiry"
                  />

                  <InputBox
                    type="text"
                    name="field_17"
                    value={formValues.field_17}
                    label="Bom price (in lakhs)*"
                    fieldName="BOM Price"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_17}
                    //isNumericWithDecimal
                    maxLength={10}
                    isNumericWithDecimal
                  />

                  <InputBox
                    type="text"
                    name="field_16"
                    value={formValues.field_16}
                    label="% Discount on BOM Price*"
                    fieldName="% Discount on BOM Price"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_16}
                    isNumericWithDecimal
                    isPercentage
                    maxLength={5}
                  />
                </Row>

                <Row className="modal-row add-edit-form">
                  <MultiSearchSelect
                    name="field_15"
                    value={formValues.field_15 && formValues.field_15.results ? formValues.field_15.results : formValues.field_15 || []}
                    onChange={handleInputChange}
                    // options={getMultiSelectOptions("PG")}
                    options={pgOption}
                    label="PG*"
                    fieldName="PG"
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_15}
                    readOnly={props.action == 'View' && true}
                    // hint="Auto-populated from enquiry"
                  />

                  <MultiSearchSelect
                    name="field_24"
                    value={formValues.field_24 && formValues.field_24.results ? formValues.field_24.results : formValues.field_24 || []}
                    onChange={handleInputChange}
                    options={CompetitorOption}
                    label="Competitor"
                    fieldName="Competitor"
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_24}
                    readOnly={props.action == 'View' && true}
                    // hint="Auto-populated from enquiry"
                  />

                </Row>

                {/* <Row className="modal-row add-edit-form"> */}

                {/* <InputBox
                    type="text"
                    name="field_19"
                    value={formValues.field_19}
                    label="Dealer Margin % (if dealer order)*"
                    fieldName="Dealer Margin %"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_19}
                    isNumericWithDecimal
                    isPercentage
                    maxLength={5}
                  /> */}

                {/* <InputBox
                    type="text"
                    name="field_34"
                    value={formValues.field_34}
                    label="Dealer Order Basic Price (in lakhs)*"
                    fieldName="Dealer Order Basic Price"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_34}
                    isNumericWithDecimal
                    maxLength={10}
                  /> */}

                {/* <InputBox
                    type="text"
                    name="field_27"
                    value={formValues.field_27}
                    label="Overall Outflow %*"
                    fieldName="Overall Outflow %"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_27}
                    isNumericWithDecimal
                    isPercentage
                    maxLength={5}
                  /> */}


                {/* </Row> */}

                <Row className="modal-row add-edit-form">

                  {/* <InputBox
                    type="text"
                    name="field_21"
                    value={formValues.field_21}
                    label="Dealer SAC/ORC"
                    fieldName="Dealer SAC/ORC"
                    readOnly={props.action == 'View' && true}
                    onChange={handleInputChange}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_21}
                    isNumericWithDecimal
                    maxLength={10}
                  /> */}

                  <InputBox
                    type="text"
                    name="field_18"
                    value={formValues.field_18}
                    label="Customer Order Basic Price (in lakhs)*"
                    fieldName="Customer Order Basic Price"
                    onChange={handleInputChange}
                    readOnly
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_18}
                    isNumericWithDecimal
                    maxLength={10}
                    disabled
                  />

                  <SearchSelect
                    name="field_22"
                    value={formValues.field_22}
                    option={getDropDownOptions('ScopeOfInstallation')}
                    label="Scope of Installation*"
                    readOnly={props.action == 'View' && true}
                    id="field_22"
                    fieldName="Scope of Installation"
                    onChange={handleInputChange}
                    placeholder="Select Scope of Installation"
                    setError={setErrors}
                    error={errors.field_22}
                    required
                  />

                  <InputBox
                    type="textarea"
                    name="field_23"
                    value={formValues.field_23}
                    label="Reason for High Discount"
                    fieldName="Reason for High Discount"
                    onChange={handleInputChange}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_23}
                    rows={3}
                    readOnly={props.action == 'View' && true}
                    maxLength={500}
                  />

                </Row>

                <Row className="modal-row add-edit-form">
                  <InputBox
                    type="date"
                    name="field_28"
                    value={formValues.field_28?.split("T")[0]}
                    label="Order Expected By*"
                    fieldName="Order Expected By"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_28}
                  />
                  
                  <InputBox
                    type="date"
                    name="field_29"
                    value={formValues.field_29?.split("T")[0]}
                    label="Delivery Expected By*"
                    fieldName="Delivery Expected By"
                    onChange={handleInputChange}
                    readOnly={props.action == 'View' && true}
                    required
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    error={errors.field_29}
                  />

                  <SearchSelect
                    name="field_30"
                    value={formValues.field_30}
                    option={insuranceOptions}
                    label="LD if Any*"
                    id="field_30"
                    fieldName="LD if Any"
                    onChange={handleInputChange}
                    placeholder="Select LD if Any"
                    setError={setErrors}
                    readOnly={props.action == 'View' && true}
                    error={errors.field_30}
                    required
                  />

                </Row>

                {formValues.field_30 === "Yes" && (
                  <Row className="modal-row add-edit-form">

                    <InputBox
                      type="text"
                      name="LDperweek"
                      value={formValues.LDperweek}
                      label="LD per Week"
                      fieldName="LD per Week"
                      onChange={handleInputChange}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      readOnly={props.action == 'View' && true}
                      error={errors.LDperweek}
                      isNumericWithDecimal
                      maxLength={5}
                    />

                    <InputBox
                      type="text"
                      name="MaxLD"
                      value={formValues.MaxLD}
                      label="Max LD"
                      fieldName="Max LD"
                      onChange={handleInputChange}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      setError={setErrors}
                      readOnly={props.action == 'View' && true}
                      error={errors.MaxLD}
                      isNumericWithDecimal
                      maxLength={5}
                    />

                    <InputBox
                      type="textarea"
                      name="field_35"
                      value={formValues.field_35}
                      label="LD Clause"
                      fieldName="LD Clause"
                      onChange={handleInputChange}
                      mandatoryFields={mandatoryFields}
                      setMandatoryFields={setMandatoryFields}
                      readOnly={props.action == 'View' && true}
                      setError={setErrors}
                      error={errors.field_35}
                      maxLength={100}
                    />


                  </Row>
                )}

                <Row className="modal-row add-edit-form">

                  <InputBox
                    type="textarea"
                    name="field_31"
                    value={formValues.field_31}
                    label="Remarks"
                    fieldName="Remarks"
                    onChange={handleInputChange}
                    mandatoryFields={mandatoryFields}
                    setMandatoryFields={setMandatoryFields}
                    setError={setErrors}
                    readOnly={props.action == 'View' && true}
                    error={errors.field_31}
                    rows={3}
                    maxLength={500}
                  />

                  <SearchSelect
                    name="Insurance"
                    value={formValues.Insurance}
                    option={insuranceOptions}
                    label="Any Specific Insurance Demanded in PO*"
                    id="Insurance"
                    fieldName="Insurance"
                    onChange={handleInputChange}
                    placeholder="Select Insurance"
                    readOnly={props.action == 'View' && true}
                    setError={setErrors}
                    error={errors.Insurance}
                    required
                  />
                </Row>

                {props.action !== 'View' ? (
                <Row className="add-edit-form drag_file low-margin">
                    <Row style={{ display: "grid", marginBottom: '1rem' }}>
                      <span className="attachment-title">Attachment</span>
                      <span className="attachment-sub-title">NOTE: Total size limit is 50MB (only pdf or excel file are allowed)</span>
                    </Row>
                    <DragDropRender
                      // supportedFilesLabel="NOTE: Max 25MB per file, 5 files allowed. Total size limit: 50MB"
                      val={obj.AddDiscountDocument}
                      name={"AddDiscountDocument"}
                      label={"File upload"}
                      handleChangeEvent={(params) => handleChangeStatus(params, "AddDiscountDocument")}
                      handleDeleteDocEvent={(params) => handleDeleteDocument(params, "AddDiscountDocument")}
                      handleDownloadDocEvent={handleUploadedFileDownload}
                      action={"Edit"}
                      // required={true}
                      isSetError={true}
                      {...commonFileUploadProps}
                      {...commonProps}
                    />
                  </Row>
                ):(
                   <Row className="add-edit-form   drag_file low-margin">
                      <Row style={{ display: "grid", marginBottom: '1rem' }}>
                        <span className="attachment-title">Attached Files:</span>
                      </Row>
                      {Array.isArray(fileNames) && fileNames.length > 0 ? (
                        <Row>
                          <Col className="file-attachment">
                            {fileNames.map((file, i) => (
                              <div key={i} className='inline-buttons uploaded-wrapper'>
                                <span>
                                  <Form.Text
                                    className="fileupload-name view-file-name"
                                    onClick={() => handleFileDownload(file)}
                                    title={file}
                                  >
                                    {file}
                                  </Form.Text>
                                </span>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      ) : (
                        <span className="no-files-message">No files attached</span>
                      )}
                    </Row>
                )}

                {props.action === 'View' && (
                  <>
                    <Row className="modal-row add-edit-form">
                      <SearchSelect
                        name="Approvalstatus"
                        value={formValues.Approvalstatus}
                        option={getDropDownOptions('DiscountApprovalStatus')}
                        label="Approval Status*"
                        id="Approvalstatus"
                        fieldName="Approval Status"
                        onChange={handleInputChange}
                        placeholder="Select Approval Status"
                        readOnly={props.action == 'View' && true}
                        setError={setErrors}
                        error={errors.Approvalstatus}
                        required
                      />

                      <InputBox
                        type="text"
                        name="Advance"
                        value={formValues.Advance}
                        label="Advance*"
                        fieldName="Advance"
                        onChange={handleInputChange}
                        required
                        readOnly
                        hint="Hard coded value"
                        setError={setErrors}
                      />

                      <InputBox
                        type="text"
                        name="Creditperiod"
                        value={formValues.Creditperiod}
                        label="Credit Period*"
                        fieldName="Credit Period"
                        onChange={handleInputChange}
                        required
                        readOnly
                        setError={setErrors}
                        hint="Hard coded value"
                      />
                    </Row>

                    <Row className="modal-row add-edit-form">
                      <InputBox
                        type="textarea"
                        as="textarea"
                        style={{
                          'maxWidth': '96%', 
                          'minWidth': '96%', 
                          'width': '-webkit-fill-available',
                          'minHeight': `${Math.max(30, (formValues.ApproverComments || '').split('\n').length * 20 + 10)}px`,
                          'maxHeight': `${Math.max(30, (formValues.ApproverComments || '').split('\n').length * 20 + 10)}px`,
                          'resize': 'vertical',
                          'overflow': 'hidden'
                        }}
                        name="ApproverComments"
                        value={formValues.ApproverComments}
                        label="Approver Comments*"
                        fieldName="Approver Comments"
                        readOnly
                        setError={setErrors}
                      />
                    </Row>
                    <Row className="modal-row add-edit-form">
                      <InputBox
                        type="text"
                        name="LastPendingWith"
                        value={formValues.LastPendingWith}
                        label="Last Pending With*"
                        fieldName="Last Pending With"
                        readOnly
                        setError={setErrors}
                      />

                      <InputBox
                        type="text"
                        name="FinalApproverEmail"
                        value={formValues.FinalApproverEmail}
                        label="Final Approver Email*"
                        fieldName="Final Approver Email"
                        readOnly
                        setError={setErrors}
                      />
                    </Row>

                  </>)}
              </div>
            </div>
            {props.action !== 'View' && <Modal.Footer>
              <Button
                type="submit"
                variant="primary"
                disabled={!isFormValid()}
              >
                Submit
              </Button>
              <Button
                bsPrefix="reset-btn"
                className="reset-button"
                type="button"
                onClick={resetForm}
              >
                Reset
              </Button>
            </Modal.Footer>}
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DiscountAdd;